<script setup lang="ts">
  defineOptions({ name: 'AuthScreenHeader' })

  import type { PropType } from 'vue'

  import CPText from '@ui/components/CPText.vue'

  /**
   * Page-header block for ClientPortal auth screens: title and optional description.
   * Config-driven by `AuthPageLayout` so every screen shares one consistent treatment.
   */
  defineProps({
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String as PropType<string | null>,
      default: null,
    },
  })
</script>

<template>
  <div class="flex min-w-0 flex-1 flex-col mb-4">
    <CPText size="3xl" weight="semibold" class="block text-body montserrat-semibold">
      {{ title }}
    </CPText>
    <CPText v-if="description" size="sm" weight="regular" class="mt-1 block w-full break-words text-secondary montserrat-regular">
      {{ description }}
    </CPText>
  </div>
</template>
